import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { api } from "../Assets/assetsShared";
import "./EmployeeSidebar.css";

/* =========================================================
   MENU  (permission = [pageKey, action] from Role & Permission)
   section = small heading shown above the item
========================================================= */

const MENU = [
  {
    id: "dashboard",
    section: "Main",
    label: "Dashboard",
    icon: "🏠",
    to: "/admin",
    permission: ["dashboard", "view"],
  },
  {
    id: "tool",
    section: "Workspace",
    label: "Tool",
    icon: "🛠️",
    items: [
      {
        label: "Notes",
        icon: "📝",
        to: "/tools/notes",
        permission: ["notes", "view"],
      },
    ],
  },
  {
    id: "messenger",
    section: "Workspace",
    label: "Messenger",
    icon: "💬",
    items: [
      {
        label: "User wise",
        icon: "👤",
        to: "/messenger",
        end: true,
        permission: ["messenger_users", "view"],
      },
      {
        label: "Project-wise",
        icon: "📁",
        to: "/messenger/project-communication",
        permission: ["messenger_project", "view"],
      },
    ],
  },
  {
    id: "email",
    section: "Workspace",
    label: "Email",
    icon: "✉️",
    items: [
      {
        label: "Email Box",
        icon: "📥",
        to: "/email",
        permission: ["email_box", "view"],
      },
    ],
  },
  {
    id: "hr",
    section: "People",
    label: "HR",
    icon: "👥",
    items: [
      {
        label: "Timesheet",
        icon: "⏱️",
        to: "/timesheet",
        permission: ["timesheet", "view"],
      },
      {
        label: "Employee Log Detail",
        icon: "📝",
        to: "/employee-log",
        permission: ["employee_log", "view"],
      },
      {
        // only for roles that have "View All Employees" in Role & Permission
        label: "Employee Log Summary",
        icon: "📊",
        to: "/employee-log-summary",
        permission: ["employee_log", "view_all"],
      },
      {
        label: "Leave Application",
        icon: "🏖️",
        to: "/leave-application",
        permission: ["leave_application", "view"],
      },
      {
        label: "Leave Management",
        icon: "✅",
        to: "/leave-management",
        permission: ["leave_management", "view"],
      },
      {
        label: "Employee Review",
        icon: "⭐",
        to: "/employee-reviews",
        permission: ["employee_review", "view"],
      },
      {
        label: "Create Email",
        icon: "📧",
        to: "/hr/create-mail-account",
        permission: ["create_email", "view"],
      },
      {
        label: "Manage Employee",
        icon: "👥",
        to: "/manage-employees",
        permission: ["manage_employee", "view"],
      },
      {
        label: "Role & Permission",
        icon: "🔐",
        to: "/role-permissions",
        permission: ["role_permission", "view"],
      },
    ],
  },
  {
    id: "hiring",
    section: "People",
    label: "Hiring Management",
    icon: "🧑‍💼",
    items: [
      {
        label: "Hiring Dashboard",
        icon: "📊",
        to: "/hr-dashboard",
        permission: ["hiring_dashboard", "view"],
      },
      {
        label: "Job Openings",
        icon: "💼",
        to: "/hr/job-openings",
        permission: ["job_openings", "view"],
      },
      {
        label: "Candidates",
        icon: "👤",
        to: "/hr/candidates",
        permission: ["candidates", "view"],
      },
      {
        label: "Interviews",
        icon: "🗓️",
        to: "/hr/interviews",
        permission: ["interviews", "view"],
      },
      {
        label: "Offers",
        icon: "📄",
        to: "/hr/offers",
        permission: ["offers", "view"],
      },
      {
        label: "Upcoming Joinings",
        icon: "🤝",
        to: "/hr/joining",
        permission: ["joining", "view"],
      },
      {
        label: "Closed Hiring",
        icon: "✅",
        to: "/hr/closed-hiring",
        permission: ["closed_hiring", "view"],
      },
      {
        label: "Recruitment Reports",
        icon: "📈",
        to: "/hr/recruitment-reports",
        permission: ["recruitment_reports", "view"],
      },
    ],
  },
  {
    id: "finance",
    section: "Finance",
    label: "Finance",
    icon: "💰",
    items: [
      {
        label: "Finance Dashboard",
        icon: "📈",
        to: "/finance",
        end: true,
        permission: ["finance_dashboard", "view"],
      },
      {
        label: "Project Cost",
        icon: "💵",
        to: "/project-cost-report",
        permission: ["project_cost", "view"],
      },
    ],
  },
  {
    id: "bookkeeping",
    section: "Finance",
    label: "Book Keeping",
    icon: "📂",
    items: [
      {
        label: "Finance Entry",
        icon: "💳",
        to: "/finance-entry",
        permission: ["finance_entry", "view"],
      },
      {
        label: "GST R1 Sales",
        icon: "📄",
        to: "/finance/reports/gst/r1-sales",
        permission: ["gst_r1_sales", "view"],
      },
      {
        label: "GST 3B Purchase",
        icon: "📄",
        to: "/finance/reports/gst/3b-purchase",
        permission: ["gst_3b_purchase", "view"],
      },
      {
        label: "TDS Receivable",
        icon: "📥",
        to: "/finance/reports/tds/receivable",
        permission: ["tds_receivable", "view"],
      },
      {
        label: "TDS Payment",
        icon: "💳",
        to: "/finance/reports/tds/payable",
        permission: ["tds_payment", "view"],
      },
    ],
  },
  {
    id: "sales",
    section: "Finance",
    label: "Sales",
    icon: "💼",
    items: [
      {
        label: "Sales Dashboard",
        icon: "📊",
        to: "/sales/dashboard",
        permission: ["sales_dashboard", "view"],
      },
      {
        label: "Service Master",
        icon: "🛠️",
        to: "/sales/services",
        permission: ["sales_service_master", "view"],
      },
      {
        label: "Client Master",
        icon: "👥",
        to: "/sales/clients",
        permission: ["sales_client_master", "view"],
      },
      {
        label: "Bank Detail Master",
        icon: "🏦",
        to: "/sales/banks",
        permission: ["sales_bank_master", "view"],
      },
      {
        label: "Terms & Conditions",
        icon: "📋",
        to: "/sales/terms",
        permission: ["sales_terms_master", "view"],
      },
      {
        label: "Quotations",
        icon: "📝",
        to: "/sales/quotations",
        permission: ["sales_quotations", "view"],
      },
      {
        label: "Proforma Invoices",
        icon: "📄",
        to: "/sales/proforma-invoices",
        permission: ["sales_proforma_invoices", "view"],
      },
      {
        label: "Invoices",
        icon: "🧾",
        to: "/sales/invoices",
        permission: ["sales_invoices", "view"],
      },
    ],
  },
  {
    id: "purchase",
    section: "Finance",
    label: "Purchase",
    icon: "🛒",
    items: [
      {
        label: "Purchase Dashboard",
        icon: "📊",
        to: "/purchase/dashboard",
        permission: ["purchase_dashboard", "view"],
      },
      {
        label: "Quotations",
        icon: "📝",
        to: "/purchase/quotations",
        permission: ["purchase_quotations", "view"],
      },
      {
        label: "Proforma Invoices",
        icon: "📄",
        to: "/purchase/proforma-invoices",
        permission: ["purchase_proforma_invoices", "view"],
      },
      {
        label: "Invoices",
        icon: "🧾",
        to: "/purchase/invoices",
        permission: ["purchase_invoices", "view"],
      },
      {
        label: "Vendor Master",
        icon: "🏢",
        to: "/purchase/vendors",
        permission: ["purchase_vendor_master", "view"],
      },
    ],
  },
  {
    id: "admin",
    section: "Admin",
    label: "Admin & Internal Management",
    icon: "🏢",
    sectionLabel: "Asset",
    items: [
      {
        label: "My Hardware",
        icon: "🖥️",
        to: "/my-hardware",
        permission: ["hardware_employee", "view"],
      },
      {
        label: "Software All Staff",
        icon: "📦",
        to: "/software",
        permission: ["software_all", "view"],
      },
      {
        label: "Hardware All Staff",
        icon: "🗄️",
        to: "/hardware",
        permission: ["hardware_all", "view"],
        extraPaths: ["/hardware-destroyed"],
      },
    ],
  },
];

const FALLBACK_PERMISSIONS = { dashboard: ["view"] };

const itemMatches = (item, path) =>
  [item.to, ...(item.extraPaths || [])].some((base) =>
    item.end ? path === base : path === base || path.startsWith(`${base}/`),
  );

export default function EmployeeSidebar() {
  const location = useLocation();
  const [permissions, setPermissions] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [openGroup, setOpenGroup] = useState("");
  const [departments, setDepartments] = useState([]);
  const [deptOpen, setDeptOpen] = useState(false);

  // department selected in the URL (/timesheet?department=Accounts)
  const activeDept =
    new URLSearchParams(location.search).get("department") || "";

  /* ---------- load my permissions ---------- */
  useEffect(() => {
    let cancelled = false;

    api
      .get("/role-permissions/me")
      .then((res) => {
        if (cancelled) return;
        setPermissions(res.data?.permissions || {});
        setIsAdmin(Boolean(res.data?.isAdmin));
      })
      .catch(() => {
        if (!cancelled) setPermissions(FALLBACK_PERMISSIONS);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  /* ---------- load departments from the Timesheet Master ---------- */
  useEffect(() => {
    let cancelled = false;

    api
      .get("/timesheet-master")
      .then((res) => {
        if (cancelled) return;
        const rows = Array.isArray(res.data) ? res.data : [];
        setDepartments(
          Array.from(new Set(rows.map((r) => r.department).filter(Boolean))),
        );
      })
      .catch(() => {
        if (!cancelled) setDepartments([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  /* ---------- open the group of the current page ---------- */
  useEffect(() => {
    const current = MENU.find((group) =>
      group.items?.some((item) => itemMatches(item, location.pathname)),
    );

    if (current) setOpenGroup(current.id);

    // keep the Timesheet toggle open while the Timesheet page is shown
    if (
      location.pathname === "/timesheet" ||
      location.pathname.startsWith("/timesheet/")
    ) {
      setDeptOpen(true);
    }
  }, [location.pathname]);

  const has = (permission) =>
    !permission || (permissions?.[permission[0]] || []).includes(permission[1]);

  /* ---------- only what this role can see ---------- */
  const visibleMenu = (permissions ? MENU : [])
    .map((entry) =>
      entry.items
        ? {
            ...entry,
            visibleItems: entry.items.filter((item) => has(item.permission)),
          }
        : entry,
    )
    .filter((entry) =>
      entry.items ? entry.visibleItems.length : has(entry.permission),
    );

  let lastSection = "";

  return (
    <nav className="es-sidebar">
      {/* ----- brand ----- */}
      <div className="es-brand">
        <div className="es-brand-logo">S</div>

        <div className="es-brand-text">
          <strong>Softvolute ERP</strong>
          <span>{isAdmin ? "Admin Menu" : "Employee Menu"}</span>
        </div>
      </div>

      {permissions === null ? (
        <div className="es-loading">Loading menu...</div>
      ) : (
        <ul className="es-list">
          {visibleMenu.map((entry) => {
            const showSection = entry.section !== lastSection;
            lastSection = entry.section;

            const sectionHeading = showSection && (
              <li className="es-section-title">{entry.section}</li>
            );

            /* ----- single link ----- */
            if (!entry.items) {
              return (
                <React.Fragment key={entry.id}>
                  {sectionHeading}

                  <li>
                    <NavLink
                      to={entry.to}
                      end
                      className={({ isActive }) =>
                        isActive ? "es-main es-main-active" : "es-main"
                      }
                    >
                      <span className="es-left">
                        <span className="es-icon">{entry.icon}</span>
                        <span className="es-label">{entry.label}</span>
                      </span>
                    </NavLink>
                  </li>
                </React.Fragment>
              );
            }

            /* ----- group with sub links ----- */
            const isOpen = openGroup === entry.id;
            const hasActiveChild = entry.visibleItems.some((item) =>
              itemMatches(item, location.pathname),
            );

            return (
              <React.Fragment key={entry.id}>
                {sectionHeading}

                <li>
                  <button
                    type="button"
                    className={`es-main es-group ${hasActiveChild ? "es-has-active" : ""}`}
                    onClick={() => setOpenGroup(isOpen ? "" : entry.id)}
                  >
                    <span className="es-left">
                      <span className="es-icon">{entry.icon}</span>
                      <span className="es-label">{entry.label}</span>
                    </span>

                    <span className={`es-arrow ${isOpen ? "open" : ""}`}>
                      ▾
                    </span>
                  </button>

                  {isOpen && (
                    <ul className="es-sub">
                      {entry.sectionLabel && (
                        <li className="es-sub-heading">{entry.sectionLabel}</li>
                      )}

                      {entry.visibleItems.map((item) => {
                        const isTimesheet = item.to === "/timesheet";
                        const pathMatches = itemMatches(
                          item,
                          location.pathname,
                        );

                        /* ----- Timesheet: toggle with departments inside ----- */
                        if (isTimesheet) {
                          return (
                            <li key={item.to}>
                              <button
                                type="button"
                                className={`es-sub-link es-sub-toggle ${
                                  pathMatches ? "es-sub-active" : ""
                                }`}
                                onClick={() => setDeptOpen((open) => !open)}
                              >
                                <span className="es-sub-icon">{item.icon}</span>
                                <span className="es-sub-text">
                                  {item.label}
                                </span>
                                <span
                                  className={`es-sub-arrow ${
                                    deptOpen ? "open" : ""
                                  }`}
                                >
                                  ▾
                                </span>
                              </button>

                              {deptOpen && departments.length > 0 && (
                                <ul className="es-dept-list">
                                  {departments.map((dept) => (
                                    <li key={dept}>
                                      <NavLink
                                        to={`/timesheet?department=${encodeURIComponent(dept)}`}
                                        className={() =>
                                          pathMatches && activeDept === dept
                                            ? "es-dept-link es-dept-active"
                                            : "es-dept-link"
                                        }
                                      >
                                        {dept}
                                      </NavLink>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        }

                        /* ----- normal sub link ----- */
                        return (
                          <li key={item.to}>
                            <NavLink
                              to={item.to}
                              className={() =>
                                pathMatches
                                  ? "es-sub-link es-sub-active"
                                  : "es-sub-link"
                              }
                            >
                              <span className="es-sub-icon">{item.icon}</span>
                              <span>{item.label}</span>
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      )}
    </nav>
  );
}
